import { axiosInstance } from '.'
import { GET_BLOG_POST_BY_SLUG, GET_BLOG_POSTS } from './endpoints'

export const blogServices = {
  getBlogPosts: async (params: { [key: string]: string }, headers: { [key: string]: string }) => {
    try {
      const res = await axiosInstance.get(GET_BLOG_POSTS, {
        headers: headers,
        params: params,
      })
      return res.data
    } catch (error: any) {
      return error.response
    }
  },
  getBlogPostBySlug: async (slug: string, headers: { [key: string]: string }) => {
    try {
      const data = await axiosInstance.get(GET_BLOG_POST_BY_SLUG(slug), {
        headers: headers,
      })
      return data
    } catch (error: any) {
      return error.response
    }
  },
}
